module.exports = __webpack_public_path__ + "img/test.60287e26.png";